import ConsoleApi from "apps/console/enums/consoleApi";
import { ApiConsoleUser, ApiEventSeries, ApiRole } from "./types";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";

export function getConsoleUserListQueryKey(contextId?: string) {
  return getApiQueryKey(getConsoleUserListApi(contextId), { pathParams: { contextId } });
}

function getConsoleUserListApi(contextId?: string) {
  return contextId ? ConsoleApi.GET_CONSOLE_USER_BY_CONTEXT : ConsoleApi.CONSOLE_USER_LIST;
}

export function useGetConsoleUsersList({
  isEnabled,
  successHandler,
  contextId
}: {
  isEnabled: boolean;
  successHandler?: ({ data }: { data: Array<ApiConsoleUser> }) => void;
  contextId?: string;
}) {
  return useGetApiData<Array<ApiConsoleUser>>(
    getConsoleUserListApi(contextId),
    {
      pathParams: { contextId }
    },
    {
      enabled: isEnabled,
      onSuccess: data => {
        successHandler?.({ data });
      }
    }
  );
}

export function useGetEventSeriesList() {
  return useGetApiData<Array<ApiEventSeries>>(ConsoleApi.EVENT_SERIES_LIST);
}

export function useGetRoles() {
  return useGetApiData<Array<ApiRole>>(ConsoleApi.FIND_ALL_ROLE);
}

export function useGetRolesForClientUser({ contextId }: { contextId?: string }) {
  return useGetApiData<Array<ApiRole>>(
    ConsoleApi.GET_ROLE_FOR_CLIENT_USER,
    { params: { contextId } },
    { enabled: Boolean(contextId) }
  );
}
